import { render, staticRenderFns } from "./kk.vue?vue&type=template&id=0a764316&scoped=true"
import script from "./kk.vue?vue&type=script&lang=js"
export * from "./kk.vue?vue&type=script&lang=js"
import style0 from "./kk.vue?vue&type=style&index=0&id=0a764316&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a764316",
  null
  
)

export default component.exports